import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ModalIndex from "@Modals/layout/index";
import {
  ACTIVE_TIMECLOCK_CONFIRMATION_EVENT
} from "@services/activeTimeclockConfirmation.service";

function ActiveTimeclockConfirmationModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [resolver, setResolver] = useState(null);
  const { t } = useTranslation("pointage.webCam");

  useEffect(() => {
    const handleConfirmationRequest = (event) => {
      setResolver(() => event.detail.resolve);
      setIsOpen(true);
    };

    window.addEventListener(
      ACTIVE_TIMECLOCK_CONFIRMATION_EVENT,
      handleConfirmationRequest
    );

    return () => {
      window.removeEventListener(
        ACTIVE_TIMECLOCK_CONFIRMATION_EVENT,
        handleConfirmationRequest
      );
    };
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    resolver?.(false);
    setResolver(null);
  }, [resolver]);

  const continueAction = useCallback(() => {
    setIsOpen(false);
    resolver?.(true);
    setResolver(null);
  }, [resolver]);

  return (
    <ModalIndex
      isOpen={isOpen}
      widthType="large"
      withoutTitle
      withCloseCroix
      closeOnOutsideClick={false}
      onClickClose={closeModal}
      buttonCancelOptions={{
        click: closeModal,
        color: "outlined",
        title: t("Annuler")
      }}
      buttonOptions={{
        click: continueAction,
        color: "orange",
        title: t("Continuer")
      }}
    >
      <div className="arh-mx-auto arh-mt-14 arh-max-w-[44rem] arh-text-center mobile-768:arh-mt-10">
        <p className="arh-font-poppins arh-text-2xl arh-font-bold arh-leading-[2.8rem] arh-text-[#2B2B2B] mobile-768:arh-text-xl mobile-768:arh-leading-8">
          {t("Cet employé a déjà un pointage en cours")}
          <br />
          {t("Cet ajout d'heures annulera son pointage actif")}
          <br />
          {t("Souhaitez-vous continuer")}
        </p>
      </div>
    </ModalIndex>
  );
}

export default ActiveTimeclockConfirmationModal;
